export default __webpack_public_path__ + "static/pers-857f23fa361c6660b472069f4abc6f87.jpg";